import { Controller } from "@hotwired/stimulus"

// The export modal's Format → Layout → File type reveal (TASK-229.3,
// doc-33). Picking "PDF report" (single modal) / "PDF reports" (bulk modal)
// hides the spreadsheet fields entirely; picking the spreadsheet option
// reveals the Layout select (bulk: only for a uniform selection) and a File
// type control that shows only the formats the CHOSEN source actually
// offers — hidden outright when it offers only one.
export default class extends Controller {
  static targets = ["kindRadio", "sheetFields", "layoutSelect", "fileTypeWrap", "fileTypeRadio"]
  static values = { sources: Array }

  connect() {
    this.toggle()
    this.syncFormats()
  }

  toggle() {
    const sheet = this.kindRadioTargets.some(radio => radio.checked && radio.value !== "pdf" && radio.value !== "pdf_zip")
    this.sheetFieldsTarget.classList.toggle("hidden", !sheet)
  }

  syncFormats() {
    if (!this.hasFileTypeWrapTarget) return

    const formats = this.currentFormats()

    this.fileTypeRadioTargets.forEach(radio => {
      const allowed = formats.includes(radio.value)
      radio.closest("label")?.classList.toggle("hidden", !allowed)
      radio.disabled = !allowed
    })

    const checked = this.fileTypeRadioTargets.find(radio => radio.checked && formats.includes(radio.value))
    if (!checked) {
      const first = this.fileTypeRadioTargets.find(radio => formats.includes(radio.value))
      if (first) first.checked = true
    }

    this.fileTypeWrapTarget.classList.toggle("hidden", formats.length <= 1)
  }

  currentFormats() {
    if (!this.hasLayoutSelectTarget) {
      // No Layout select at all (a mixed-form bulk selection): the single
      // implicit "main, core columns only" source always offers both.
      return this.sourcesValue[0]?.formats || []
    }

    const source = this.sourcesValue.find(s => s.id === this.layoutSelectTarget.value)
    return source ? source.formats : []
  }
}
